import { supabase } from './api'

/**
 * Latest register date for a student (YYYY-MM-DD string from DB).
 */
export async function getStudentRegisterDate(studentId) {
	const { data, error } = await supabase
		.from('goalstrackerdate')
		.select('registerdate')
		.eq('studentId', studentId)
		.order('id', { ascending: false })
		.limit(1)
		.maybeSingle()

	if (error) {
		throw new Error(error.message || 'Failed to fetch goalstrackerdate')
	}

	if (!data?.registerdate) return null

	const d = data.registerdate
	return typeof d === 'string' ? d.slice(0, 10) : d
}

/**
 * Insert if no row for student, else update the latest row.
 */
export async function upsertStudentRegisterDate(studentId, registerdateIso) {
	const { data: rows, error: fetchError } = await supabase
		.from('goalstrackerdate')
		.select('id')
		.eq('studentId', studentId)
		.order('id', { ascending: false })
		.limit(1)

	if (fetchError) {
		throw new Error(fetchError.message || 'Failed to read goalstrackerdate')
	}

	if (rows?.length > 0) {
		const { data, error } = await supabase
			.from('goalstrackerdate')
			.update({ registerdate: registerdateIso })
			.eq('id', rows[0].id)
			.select()

		if (error) {
			throw new Error(error.message || 'Failed to update goalstrackerdate')
		}
		return data
	}

	const { data, error } = await supabase
		.from('goalstrackerdate')
		.insert({ studentId, registerdate: registerdateIso })
		.select()

	if (error) {
		throw new Error(error.message || 'Failed to insert goalstrackerdate')
	}

	return data
}
